import { ChangeEvent, cloneElement, memo, useRef, useState } from "react";
import { PreviewBeforeUpload } from "../preview-file";
import { notification } from "antd";

interface AttachFileProps {
  children: JSX.Element;
  accept: string;
  maxSize: number;
  multiple: boolean;
  value: File[];
  initialValue: string[];
  onChange: (files: File[]) => void;
}

export const AttachFile = memo((props: Partial<AttachFileProps>) => {
  const {
    children = <div />,
    accept = ".png, .jpg, .jpeg,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    multiple = true,
    value = [],
    onChange = () => {},
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const [files, setFiles] = useState<File[]>(value);

  const handleMaxSize = (fileList: File[]) => {
    const sizeFileList = fileList.map((e) => e.size);
    const hasOverSizeFile = sizeFileList.some((e) => e > 4096000);
    if (hasOverSizeFile) {
      notification.error({
        message: "File quá dung lượng",
        description: "Chọn file tối đa dung lượng 4MB",
      });
      return [];
    }
    return fileList;
  };

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const fileList = Array.from((event.target?.files ?? []) as File[]);
    if (fileList.length > 0) {
      const updateFile = [...files, ...handleMaxSize(fileList)];
      setFiles(updateFile);
      onChange(updateFile);
    }
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };
  const onChangeFile = (values: any) => {
    setFiles(values);
    onChange(values);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        hidden
        multiple={multiple}
        accept={accept}
        onChange={onInputChange}
        size={4096}
      />
      <div style={{ cursor: "pointer", marginBottom: "0.5rem" }}>
        {cloneElement(children, {
          onClick: () => (inputRef.current ? inputRef.current.click() : null),
        })}
      </div>
      <PreviewBeforeUpload items={files} onChange={onChangeFile} isRemove />
    </>
  );
});
